import { useRef } from 'react';

export default function Hero() {
  const sectionRef = useRef(null);

  return (
    <section
      ref={sectionRef}
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden grain bg-bg"
    >
      {/* Subtle vignette */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-bg/40 via-transparent to-bg" />

      {/* Foreground content */}
      <div className="relative z-10 mx-auto max-w-[1440px] px-6 md:px-10 pt-40 md:pt-44 pb-24 min-h-[100svh] flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="kicker" data-testid="hero-kicker">Interior Designer · Bristol UK</span>
          <span className="kicker hidden md:inline">2026 / Folio</span>
        </div>

        <div className="mt-10 md:mt-0 max-w-5xl">
          <h1
            data-testid="hero-title"
            className="font-display font-light text-ink leading-[0.95] tracking-tight text-[clamp(3rem,8vw,8rem)]"
          >
            Designing interiors,
            <br />
            that <span className="italic font-normal text-crimson">tell a story</span>.
          </h1>
          <p
            data-testid="hero-sub"
            className="mt-8 max-w-xl text-base md:text-lg text-sub leading-relaxed"
          >
            Through this portfolio, I share a selection of projects, ideas, and design explorations
            that reflect my approach to creating interiors that are both purposeful and personal.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-pod"
              onClick={() => document.getElementById('pod-bristol')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-primary"
            >
              View Pod Bristol <span aria-hidden>↘</span>
            </button>
            <button
              data-testid="hero-cta-projects"
              onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-ghost"
            >
              Earlier Work
            </button>
          </div>
        </div>

        <div className="mt-16 md:mt-0">
          <div className="flex items-center gap-3 text-sub">
            <span className="block h-px w-10 bg-ink/40" />
            <span className="text-[11px] tracking-[0.3em] uppercase">Scroll</span>
          </div>
        </div>
      </div>
    </section>
  );
}
